import React from "react";
import {
  BiEdit,
  BiGroup,
  BiCodeAlt,
  BiRocket,
} from "react-icons/bi";

const HowToParticipate = () => {
  const steps = [
    {
      title: "سجّل في نموذج التسجيل",
      description: "املأ نموذج التسجيل عبر الموقع بمعلوماتك ومهاراتك البرمجية",
      Icon: BiEdit,
      colorClass: "yellow",
    },
    {
      title: "كوّن فريقك",
      description:
        "بعد القبول، كوّن فريقًا مع مطورين آخرين (2-4 أعضاء) أو شارك فرديًا",
      Icon: BiGroup,
      colorClass: "emerald-500",
    },
    {
      title: "طوّر أداتك",
      description:
        "طوّر أداة مفتوحة المصدر تخدم المطورين العرب خلال فترة الهاكاثون",
      Icon: BiCodeAlt,
      colorClass: "purple",
    },
    {
      title: "قدم مشروعك",
      description:
        "تقديم مشروعك في مقطع فيديو ورفع المقطع وروابط المشروع على الموقع",
      Icon: BiRocket,
      colorClass: "yellow",
    },
  ];

  return (
    <section className="relative py-20 md:py-32 bg-dark-blue overflow-hidden">
                    <div className="absolute z-10 top-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-blue"
          ></path>
        </svg>
      </div>
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 uppercase tracking-wide">
              طريقة المشاركة
            </h2>
            <div className="w-24 h-1 bg-yellow mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-white/80">أربع خطوات بسيطة للانضمام</p>
          </div>

          {/* Steps Grid */}
          <div className="relative">
            {/* Connection Line (Desktop) */}
            <div className="hidden lg:block absolute top-20 left-0 right-0 h-0.5 bg-white/20 z-0"></div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {steps.map((step, index) => {
                const IconComponent = step.Icon;
                return (
                  <div
                    key={index}
                    className="relative group flex flex-col items-center"
                  >
                    {/* Step Card */}
                    <div className="relative bg-blue rounded-3xl p-6 transition-all  hover:scale-105 z-10 w-full">
                      {/* Icon */}
                      <div
                        className={`text-6xl mb-4 flex items-center justify-center text-${step.colorClass}`}
                      >
                        <IconComponent />
                      </div>

                      {/* Title */}
                      <h3
                        className={`text-xl font-semibold text-white mb-3 text-center leading-tight`}
                      >
                        {step.title}
                      </h3>

                      {/* Description */}
                      <p className="text-white/70 text-sm text-center leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToParticipate;
